// UserGeneralDetailsComponent.ts

import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {FormControlCollectorDirective} from '../../../directives/form-control-collector.directive';
import {UserFormFactory} from '../../../services/user-form.factory';
import {UserFormErrorComponent} from '../components/user-form-error.component';
import {AutoTabIndexDirective} from '@shared/ui';
@Component({
	selector: 'dc-user-form-permissions',
	styleUrls: ['../user-form.styles.scss'],
	imports: [ReactiveFormsModule, AutoTabIndexDirective, FormControlCollectorDirective, TranslateModule, UserFormErrorComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<div class="section-fields-container" [formGroup]="parentForm()">
			@if (parentForm().get('permissions')) {
				<div class="options-container" formGroupName="permissions">
					<label for="permissions-group" class="communication-preferences form-field-label">
						{{ 'user.form.section.permissions.label' | translate }}
					</label>
					@for (option of userFormRoles; track option) {
						<div id="permissions-group" class="option-item">
							<input type="checkbox" [id]="'permission-' + option" [formControlName]="option" autoTabIndex />
							<label [for]="'permission-' + option">
								{{ 'struct.user-edit.' + option?.toLowerCase() | translate }}
							</label>
						</div>
					}
				</div>
				<dc-user-form-error [parentForm]="parentForm()" controlSection="Permissions" controlName="permissions" [isInvalidFn]="isInvalid" />
			}
		</div>
	`,
})
export class UserFormPermissionsComponent {
	private readonly userFormFactory = inject(UserFormFactory);
	protected readonly isInvalid = this.userFormFactory.isInvalidFnFactory<'Permissions'>({checkDirty: false});

	readonly parentForm = input.required<FormGroup>();

	// Define permission options separately
	public readonly userFormRoles = this.userFormFactory.PermissionsSection.userFormRoles;
}
